export const generateAsyncAction = async ({
  onSuccessAction,
  onFailAction,
  asyncApiMethod,
  request
}) => {
  const defaultDataToDispatch = {
    error: true,
    title: "Something went wrong",
    message: "Unknown Error"
  };
  let actionToDispatch = onFailAction;
  let dataToDispatch = defaultDataToDispatch;
  try {
    const serverResult = await asyncApiMethod(request);
    if (!serverResult) {
      dataToDispatch.message = "Server failed to provide the data";
    } else if (serverResult.error) {
      dataToDispatch.message =
        serverResult.message || defaultDataToDispatch.message;
    } else if (!serverResult.data) {
      dataToDispatch.message =
        serverResult.message || "No data returned from the server";
    } else {
      dataToDispatch.payload = serverResult.data;
      dataToDispatch.request = request;
      actionToDispatch = onSuccessAction;
    }
  } catch (ex) {
    dataToDispatch.message = ex.message || dataToDispatch.message;
  }
  return actionToDispatch(dataToDispatch);
};



// WEBPACK FOOTER //
// ./src/actions/generateAsyncAction.js